// useAuth.js
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const PUBLIC_ROUTES = ["/privacidad"];

const useAuth = (user) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!user && !PUBLIC_ROUTES.includes(location.pathname)) {
      navigate("/login");
    }
  }, [user, navigate, location.pathname]);

  return user;
};

export default useAuth;
